import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { i18n } from './plugins/i18n'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import noA11y from '@/directives/noA11y'

// Register the GSAP plugin
gsap.registerPlugin(ScrollToPlugin)

// Create the Vue application
const app = createApp(App)

app.directive('no-a11y', noA11y)

// Set up GSAP as a global property
app.config.globalProperties.$gsap = gsap

// Create and use Pinia as the store
const pinia = createPinia()
app.use(pinia)

// Use i18n for internationalization
app.use(i18n)

// Mount the application
app.mount('#product-list')
